import React, { Component } from 'react';
import './print.css';

function Row({ data, index }) {
  const dataArray = Object.values(data);
  return (
    <tr>
      <td>{index}</td>
      {dataArray.map((value, i) => {
        return <td key={ i }>{value}</td>;
      })}
    </tr>
  );
}

export default class Print extends Component {
  state = { puskesmasProfile: {} };
  componentDidMount() {
    this.setState(
      state =>
        (state.puskesmasProfile = JSON.parse(
          localStorage.getItem('puskesmasProfile')
        ))
    );
  }

  render() {
    const datas = this.props.datas
      ? this.props.datas.map(this.props.columnMapper)
      : [];
    return (
      <div>
        <h1 style={ { textAlign: 'center' } }>{this.state.puskesmasProfile.name}</h1>
        <h2 style={ { textAlign: 'center' } }>{this.state.puskesmasProfile.address}</h2>
        <div>
          <table className='print'>
            <thead>
              <tr>
                {this.props.headers.map((header, i) => {
                  return (
                    <th key={ i } scope='col'>
                      {header}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {datas.length > 0 &&
                datas.map((data, i) => {
                  return <Row key={ i } data={ data } index={ i + 1 } />;
                })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
